<div
  class="fixed top-0 left-0 h-screen w-[250px] flex flex-col select-none bg-gradient-to-b from-[#2a446e] via-[#345585] to-[#40689a] text-white shadow-xl"
>
  <img
    src="assets/logos/white.png"
    alt="Logo"
    class="w-[200px] ml-3 mt-8 z-40 flex-shrink-0 cursor-pointer"
    [routerLink]="['/home']"
  />
  @if (isStaging) {
    <span class="ml-4 mt-1 text-xs text-warning font-medium tracking-widest uppercase">Staging</span>
  }

  <div
    #scrollContainer
    (scroll)="checkScroll()"
    class="mt-[25px] sidebar-scroll ml-1 overflow-y-auto flex-1 min-h-0"
  >
    @for (item of primaryNavigationItems; track item.route) {
      <app-sidebar-item
        [icon]="item.icon"
        [label]="item.label"
        [routerLink]="[item.route]"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
    }
  </div>

  <div
    [ngClass]="!hasScrollbar ? 'opacity-0' : 'opacity-100'"
    class="w-full text-center text-[12px] text-white/80 py-1 transition duration-300"
    (click)="scrollDown()"
  >
    ↓ Scrollen um alle anzusehen ↓
  </div>

  <div class="flex-shrink-0">
    <!-- <app-sidebar-taxicenter-dropdown> </app-sidebar-taxicenter-dropdown> -->

    @for (item of secondaryNavigationItems; track item.route) {
      <app-sidebar-item
        class="mb-1"
        [icon]="item.icon"
        [label]="item.label"
        [routerLink]="[item.route]"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
    }
    <app-sidebar-item
      class="mb-1"
      icon="logout"
      label="Logout"
      (click)="logout()"
    ></app-sidebar-item>
  </div>
</div>
